//Require helpers JS
require('./theme/helpers/_vh');
require('./theme/helpers/_accessibility');
require('./theme/helpers/_checkout-checkbox');

//Require core theme JS
require('./theme/core/_buttons');
require('./theme/core/_careers');
require('./theme/core/_footer');
require('./theme/core/_feedback');
require('./theme/core/_selects');
require('./theme/core/_sliders');
require('./theme/core/_news');
require('./theme/core/_notices');
require('./theme/core/_search-bar');
require('./theme/core/_preferred-branch');
require('./theme/core/_pressure');
require('./theme/core/_to-top');

//Require navigation JS
require('./theme/nav/_desktop');
require('./theme/nav/_mobile');
require('./theme/nav/_sticky');
require('./theme/nav/_search');